// Minimal country dial codes list for searchable selection
export const COUNTRY_OPTIONS = [
  { name: 'India', iso2: 'IN', iso3: 'IND', dialCode: '+91' },
  { name: 'United States', iso2: 'US', iso3: 'USA', dialCode: '+1' },
  { name: 'Canada', iso2: 'CA', iso3: 'CAN', dialCode: '+1' },
  { name: 'United Kingdom', iso2: 'GB', iso3: 'GBR', dialCode: '+44' },
  { name: 'Australia', iso2: 'AU', iso3: 'AUS', dialCode: '+61' },
  { name: 'United Arab Emirates', iso2: 'AE', iso3: 'ARE', dialCode: '+971' },
  { name: 'Singapore', iso2: 'SG', iso3: 'SGP', dialCode: '+65' },
  { name: 'Germany', iso2: 'DE', iso3: 'DEU', dialCode: '+49' },
  { name: 'France', iso2: 'FR', iso3: 'FRA', dialCode: '+33' },
  { name: 'Netherlands', iso2: 'NL', iso3: 'NLD', dialCode: '+31' },
  { name: 'Switzerland', iso2: 'CH', iso3: 'CHE', dialCode: '+41' },
  { name: 'Japan', iso2: 'JP', iso3: 'JPN', dialCode: '+81' },
  { name: 'China', iso2: 'CN', iso3: 'CHN', dialCode: '+86' },
  { name: 'Indonesia', iso2: 'ID', iso3: 'IDN', dialCode: '+62' },
  { name: 'Philippines', iso2: 'PH', iso3: 'PHL', dialCode: '+63' },
  { name: 'Malaysia', iso2: 'MY', iso3: 'MYS', dialCode: '+60' },
  { name: 'Thailand', iso2: 'TH', iso3: 'THA', dialCode: '+66' },
  { name: 'Vietnam', iso2: 'VN', iso3: 'VNM', dialCode: '+84' },
  { name: 'Nepal', iso2: 'NP', iso3: 'NPL', dialCode: '+977' },
  { name: 'Bangladesh', iso2: 'BD', iso3: 'BGD', dialCode: '+880' },
  { name: 'Sri Lanka', iso2: 'LK', iso3: 'LKA', dialCode: '+94' },
  { name: 'Saudi Arabia', iso2: 'SA', iso3: 'SAU', dialCode: '+966' },
  { name: 'Qatar', iso2: 'QA', iso3: 'QAT', dialCode: '+974' },
  { name: 'Kuwait', iso2: 'KW', iso3: 'KWT', dialCode: '+965' },
  { name: 'Oman', iso2: 'OM', iso3: 'OMN', dialCode: '+968' },
  { name: 'Bahrain', iso2: 'BH', iso3: 'BHR', dialCode: '+973' },
];


